import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextPro = createSVG({
    width: 48,
    children: (jsx("path", { d: "M12.651 6.231H8.35V17.77h2.274v-3.791h2.027c2.226 0 3.94-1.714 3.94-3.873S14.876 6.23 12.65 6.23m0 5.62h-2.027V8.359h2.027c.973 0 1.682.741 1.682 1.747 0 .989-.71 1.747-1.682 1.747m11.75 5.916h2.456l-2.555-4.351c1.32-.61 2.226-1.912 2.226-3.363a3.83 3.83 0 0 0-3.84-3.824H18.07V17.77h2.275v-4.005h1.73zm-4.054-9.411h2.34c.857 0 1.566.741 1.566 1.697s-.709 1.714-1.566 1.714h-2.34zM33.651 18c3.33 0 6-2.638 6-6 0-3.379-2.67-6-6-6s-5.983 2.621-5.983 6c0 3.362 2.654 6 5.983 6m0-2.226c-2.093 0-3.725-1.565-3.725-3.774 0-2.225 1.632-3.79 3.725-3.79s3.725 1.565 3.725 3.79c0 2.209-1.632 3.774-3.725 3.774" })),
});

export { IconTextPro };
